export type JobAddV2BundleKey = 'freemium' | 'agency' | 'hire' | 'pro' | 'plus' | 'standard' | 'live';

export const getJobAddV2BundleIdentifier = (bundle?: ApiSchema<'ActivationBundle'>): string => String(bundle?.identifier || '').toLowerCase();

export const resolveJobAddV2BundleKey = (bundle?: ApiSchema<'ActivationBundle'>): JobAddV2BundleKey | undefined => {
  const identifier = getJobAddV2BundleIdentifier(bundle);

  if (identifier.includes('freemium')) return 'freemium';
  // Legacy live-fix packages were returned with type='standard'.
  if (identifier.includes('live')) return 'live';
  if (bundle?.type === 'basic' || identifier.includes('agency') || identifier.includes('basic')) return 'agency';
  if (bundle?.type === 'hire' || identifier.includes('hire') || identifier.includes('shire')) return 'hire';
  if (bundle?.type === 'pro' || identifier.includes('pro')) return 'pro';
  if (bundle?.type === 'plus' || identifier.includes('plus')) return 'plus';
  if (bundle?.type === 'standard' || identifier.includes('standard')) return 'standard';

  return undefined;
};

export const isHireBundleForJobAddV2 = (bundle?: ApiSchema<'ActivationBundle'>): boolean =>
  resolveJobAddV2BundleKey(bundle) === 'hire';
